/**
 * Authoring-only helpers for the admin source tree builder. The ordering and
 * tree primitives live in lib/coaching/source-tree.ts, shared with the
 * coaching curriculum Sources tab; import them from there.
 */
const KIND_ACTION_VERB_SUGGESTIONS: Record<string, string> = {
  chapter: 'Read',
  section: 'Read',
  book: 'Read',
  article: 'Read',
  module: 'Complete',
  lesson: 'Complete',
  quiz: 'Complete',
  'homework set': 'Complete',
  playlist: 'Watch',
  series: 'Watch',
  video: 'Watch',
}

export const ACTION_VERB_CHIPS = ['Read', 'Watch', 'Complete', 'Do'] as const

export function suggestedActionVerb(kind: string): string | null {
  return KIND_ACTION_VERB_SUGGESTIONS[kind.trim().toLowerCase()] ?? null
}
